export const TAB_KEY = 9
export const ENTER_KEY = 13
export const LEFT_KEY = 37
export const UP_KEY = 38
export const RIGHT_KEY = 39
export const DOWN_KEY = 40
export const ESC_KEY = 27
